export const useMeetingTypesPath = (scope = 'user/me') => `/app/scheduling/meeting_types/${scope}`
